import React from 'react';

const SidebarSettingAccordion = (props) => (
	<div className="panel" onClick={props.click}>
        <div className="panel-heading" id={`${props.parent}-option-${props.optionKey}`} role="tab">
            <a className="panel-title" data-parent={`#${props.parent}`} data-toggle="collapse" href={`#${props.parent}-content-${props.optionKey}`} aria-controls={`${props.parent}-content-${props.optionKey}`} aria-expanded="false">
                {props.title}
            </a>
        </div>
        <div className={`panel-collapse collapse ${(props.selectedSetting == props.optionKey ? 'in':'')}`} id={`${props.parent}-content-${props.optionKey}`} aria-labelledby={`${props.parent}-option-${props.optionKey}`} role="tabpanel">
            <div className="panel-body  font-size-12">
            		{props.children}
            </div>
        </div>
    </div>
);

export default SidebarSettingAccordion;






// WEBPACK FOOTER //
// ./components/builder/SidebarSettingAccordion.js